export default "__VITE_ASSET__DUoCYx8Z__"